module.exports = "<my-tabs (clickTabFirst)=\"openNew($event)\">\r\n  <my-tab [tabTitle]=\"'Thêm'\">\r\n  </my-tab>\r\n</my-tabs>\r\n<ng-template  let-data=\"data\" let-tabIndex=\"tabIndex\" #detailTemplate>\r\n  <detail [data]=\"data\" [tabIndex]=\"tabIndex\" id=\"tab-{{tabIndex}}\"></detail>\r\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/mytab/mytab.component.html
// module id = ../../../../../src/app/layout/mytab/mytab.component.html
// module chunks = main